import { render, staticRenderFns } from "./PhotoVerification.vue?vue&type=template&id=57993fc0"
import script from "./PhotoVerification.vue?vue&type=script&lang=js"
export * from "./PhotoVerification.vue?vue&type=script&lang=js"
import style0 from "./PhotoVerification.vue?vue&type=style&index=0&id=57993fc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports